(function() {
  if (!window.location.pathname.includes('/products/')) return;

  function getNumericPrice(text) {
    return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
  }

  function formatPrice(amount) {
    return '$' + amount.toFixed(2);
  }

  function init() {
    var basePriceEl = document.querySelector('.product-price span.price');
    if (!basePriceEl) return;

    var basePrice = getNumericPrice(basePriceEl.textContent);

    var observer = new MutationObserver(function() {
      var boldEl = document.querySelector('.bold_option_total');
      if (!boldEl) return;
      var optionsPrice = getNumericPrice(boldEl.textContent);
      basePriceEl.textContent = optionsPrice > 0 
        ? formatPrice(basePrice + optionsPrice)
        : formatPrice(basePrice);
    });

    observer.observe(document.body, { 
      childList: true, 
      subtree: true, 
      characterData: true 
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 1000);
  }
})();
